const verifyAccountStatus = (props, source) => {
  axios
    .get(`/api/verify-account-status/${source}`)
    .then((response) => {
      const userData = {
        status: response.data.status,
      }
      props.auth.updateUser(userData)
    })
    .catch((err) => {
      console.log('Error getting account status: ', err)
    })
}

export default verifyAccountStatus
